import axios from "axios";
import {appConfig} from "../config/defaultConfig";

const IROH_SERVICES = appConfig.APP.IROH_SERVICES;
const VISIBILITY_ORG = "org";
const VISIBILITY_USER = "user";

const fetchRegistrySettings = (visibility, key) =>
  axios
    .get(`${IROH_SERVICES.ROUTES.REGISTRY_SETTINGS}/${visibility}/${key}`)
    .then((response) => response.data)
    .catch((error) => {
      // Swallow 404 errors, since that means the registry value hasn't been
      // set yet. That's OK.
      if (error.status !== 404) {
        throw error;
      }
    });

const saveRegistrySettings = (visibility, key, value) =>
  key && visibility
    ? axios.put(
        `${IROH_SERVICES.ROUTES.REGISTRY_SETTINGS}/${visibility}/${key}`,
        value
      )
    : Promise.reject({
        error: {message: "Missing required field: [key] and/or [visibility]"}
      });

export const REGISTRY_KEYS = {
  DATEFORMAT: "dateFormat",
  TIMEZONE: "timezone"
};

export const fetchUserRegistrySettings = (key) =>
  fetchRegistrySettings(VISIBILITY_USER, key);

export const fetchOrgRegistrySettings = (key) =>
  fetchRegistrySettings(VISIBILITY_ORG, key);

export const saveUserRegistrySettings = (key, value) =>
  saveRegistrySettings(VISIBILITY_USER, key, value);

export const saveOrgRegistrySettings = (key, value) =>
  saveRegistrySettings(VISIBILITY_ORG, key, value);
